module.exports = __webpack_public_path__ + "static/media/kantoushanadj.1e35cbce.png";